import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "helpers/api_helper";
import { GET_DASHBOARD_DATA, GET_DASHBOARD_DATA_RECENT_ACTIVITY } from "helpers/url_helper";

export const getDashboardData = createAsyncThunk(GET_DASHBOARD_DATA, async (payload) => {

  const response = await api.post(`${GET_DASHBOARD_DATA}/${payload?.type}`, payload?.payload);
  return response;
});
export const getDashboardRecentActivity = createAsyncThunk(GET_DASHBOARD_DATA_RECENT_ACTIVITY, async (payload) => {

  const response = await api.post(`${GET_DASHBOARD_DATA_RECENT_ACTIVITY}/${payload?.type}`, payload?.payload);
  return response;
});